import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import'rxjs/Subscription';
import'rxjs/add/operator/catch';
import'rxjs/add/observable/throw';
import'rxjs/add/operator/retry';
import { HttpErrorResponse } from '@angular/common/http';
// models

import { DisciplinaColegioModel } from './../../../providers/model/disciplina-colegio.model';
import { ComboAnoColegioModel } from './../../../providers/model/combo-ano-colegio.model';
import { BloqueioNotaModel } from './../../../providers/model/bloqueio-nota.model';
import { NotasColegioModel } from '../../../providers/model/notas-colegio.model';
import { ParciaisModel } from '../../../providers/model/parciais.model';
// services

import { ConsultaColegioService } from './../../../providers/service/colegio/consulta-colegio.service';
import { Subscription } from 'rxjs/Subscription';
export class ConsultaColegioComponent implements OnInit {

  subscription: Subscription;
public habilitarCarregando: boolean = false;
public codigoEmpresa: number;
public codigoInstituicao: number;
public rgmAluno: number;
public codigoAluno: number;
public codigoCurso: number;
public listaCombo: ComboAnoColegioModel[];
public turmaSelecionada: number;
public listaDisciplina: DisciplinaColegioModel[];
public parcial: ParciaisModel[];
public disciplinaSelecionada: string = "";
/**
 * @param {?} consulta
 * @param {?} rotaAtivada
 * @param {?} router
 */
constructor(
private consulta: ConsultaColegioService,
private rotaAtivada: ActivatedRoute,
private router: Router
  ) { }
/**
 * @return {?}
 */
ngOnInit() {
    this.rotaAtivada.params.subscribe(p => {
      this.codigoEmpresa = p['codigoEmpresa'];
      this.codigoInstituicao = p['codigoInstituicao'];
      this.rgmAluno = p['rgmAluno'];
      this.codigoAluno = p['codigoAluno'];
      this.codigoCurso = p['codigoCurso'];

      this.buscaBloqueio();
    });
  }
/**
 * @return {?}
 */
private buscaBloqueio() {
    this.habilitarCarregando = false;
    this.subscription = this.consulta.getBloqueioNota(this.codigoInstituicao, this.codigoCurso)
      .subscribe(
        (bloqueio: BloqueioNotaModel) => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();

          if (bloqueio) {
            this.router.navigate(['/colegio/bloqueado', bloqueio.mensagem])
          } else {
            this.buscaCombo();
          }
        },

        (err: HttpErrorResponse) => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();

          if (err.status == 200) {
            this.buscaCombo();
          }
        }
      )
      ;
  }
/**
 * @return {?}
 */
public buscaCombo() {
    this.habilitarCarregando = true;
    this.subscription = this.consulta.getCombo(this.codigoInstituicao, this.rgmAluno, this.codigoEmpresa)
      .subscribe(
        (element: ComboAnoColegioModel[]) => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          this.listaCombo = element;
        },
        error => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          console.log("Erro ao carregar combo", error)
        }
      );
  }
/**
 * @param {?} item
 * @return {?}
 */
public changeCombo(item: any) {
    this.turmaSelecionada = item;

    this.buscaDisciplina();
  }
/**
 * @return {?}
 */
public buscaDisciplina() {
    this.habilitarCarregando = true;

    this.subscription = this.consulta.getDisciplinas(this.codigoAluno, this.codigoEmpresa, this.codigoInstituicao, this.turmaSelecionada)
      .subscribe(
        (element: DisciplinaColegioModel[]) => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();

          this.listaDisciplina = element;

          this.listaDisciplina.forEach(element => {
            let /** @type {?} */ resultado = (element.notas.length - 4) * -1;

            for (let /** @type {?} */ index = 0; index < resultado; index++) {
              element.notas.push(new NotasColegioModel)
            }
          });
        },
        error => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          console.log("Erro ao carregar combo", error)
        }
      )
  }
/**
 * @param {?} item
 * @param {?} descricao
 * @return {?}
 */
public linhaSelecionada(item: NotasColegioModel, descricao: string) {

    this.disciplinaSelecionada = descricao;

    this.buscaParcial(item.codDisc,
      this.codigoInstituicao,
      this.turmaSelecionada,
      this.codigoEmpresa,
      this.rgmAluno,
      this.codigoEmpresa,
    );
  }
/**
 * @param {?} codigoDisciplina
 * @param {?} codigoInstituicao
 * @param {?} codigoTurma
 * @param {?} codigoEmpresa
 * @param {?} rgmAluno
 * @param {?} seqNota
 * @return {?}
 */
private buscaParcial(codigoDisciplina: number,
    codigoInstituicao: number,
    codigoTurma: number,
    codigoEmpresa: number,
    rgmAluno: number,
    seqNota: number, ) {
    this.habilitarCarregando = true;
    this.parcial = [];
    this.subscription = this.consulta.getParciais(codigoDisciplina, codigoInstituicao, codigoTurma, rgmAluno, seqNota)
      .subscribe(
        (element: ParciaisModel[]) => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          this.parcial = element;
        },
        error => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          console.log("Erro ao carregar combo", error)
        }
      );
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-consulta-colegio',
  template: `
    <app-carregando *ngIf="habilitarCarregando"></app-carregando>
    <div style="text-align:center">
      <h1>
        Notas Colegio
      </h1>

    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <label for="comboAno">Turma</label>
          <select id="comboAno" class="form-control" name="comboAno" [(ngModel)]="turmaSelecionada" (change)="changeCombo($event.target.value)">
            <option *ngFor="let item of listaCombo" [value]="item.codigoTurma">{{item.ano - item.semestre}}</option>
          </select>
        </div>
      </div>
      <br>
      <div class="container-fluid">

        <div class="panel panel-default">
          <!-- Default panel contents -->
          <div class="table-responsive">
            <tbody>
              <table id="tableDisciplina" class="table">
                <tbody>
                  <tr>
                    <th width="200" rowspan="2">Disciplina</th>
                    <th width="35" rowspan="2">Faltas</th>
                    <th colspan="18">NOTAS</th>
                  </tr>
                  <tr>
                    <th width="15">1° B</th>
                    <th width="15">2° B</th>
                    <th width="15">3° B</th>
                    <th width="15">4° B</th>
                    <th width="40">Média Final</th>
                    <th width="55">Resultado</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <td>
                      <tr>
                        <th class="bimestre">MP</th>
                        <th class="bimestre">REC</th>
                        <th class="bimestre">MB</th>
                      </tr>
                    </td>

                    <td>
                      <tr>
                        <th class="bimestre">MP</th>
                        <th class="bimestre">REC</th>
                        <th class="bimestre">MB</th>
                      </tr>
                    </td>

                    <td>
                      <tr>
                        <th class="bimestre">MP</th>
                        <th class="bimestre">REC</th>
                        <th class="bimestre">MB</th>
                      </tr>
                    </td>

                    <td>
                      <tr>
                        <th class="bimestre">MP</th>
                        <th class="bimestre">REC</th>
                        <th class="bimestre">MB</th>
                      </tr>
                    </td>
                    <th></th>
                    <th></th>
                  </tr>

                  <tr *ngFor="let disciplina of listaDisciplina">

                    <td>
                      {{disciplina.disciplina}}
                    </td>
                    <td>
                      faltas
                    </td>

                    <td *ngFor="let notas of disciplina.notas">
                      <table>
                        <tr>
                          <td class="bimestre1"> {{notas.notaDis}} </td>
                          <td class="bimestre"> {{notas.notaRec}} </td>
                          <td class="bimestre">
                            <!-- Button trigger modal -->
                            <a data-toggle="modal" data-target="#modalParciais" (click)="linhaSelecionada(notas, disciplina.disciplina)">
                              {{notas.notaSin}}
                            </a>

                          </td>

                        </tr>
                      </table>
                    </td>
                    <td>{{disciplina.notaFinal}}</td>
                    <td>{{disciplina.resultado}}</td>
                  </tr>
                </tbody>
              </table>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="modalParciais" tabindex="-1" role="dialog" aria-labelledby="modalParciaisLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="modalParciaisLabel">Disciplina: {{disciplinaSelecionada}}</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card-body">
                <h4>
                  Avaliações/Atividades
                </h4>

                <table class="table table-bordered">
                  <th>
                    Descrição
                  </th>
                  <th>
                    Nota
                  </th>
                  <tr *ngFor="let digitada of parcial">
                    <td>
                      {{digitada.descricao}}
                    </td>
                    <td>
                      {{digitada.nota}}
                    </td>
                  </tr>
                </table>

              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            </div>
          </div>
        </div>
      </div>
  `,
  styles: [`
    th {
        background-color: #DBEBFF;
        border: 1px solid #A4BED4;
        font-family: Verdana, Arial, Helvetica, sans-serif;
        font-size: 13px;
        color: #006699;
        font-weight: bold;
        text-align: center;
        cursor: default;
    }

    td{
        border: 1px solid #cccccc;
        font-family: Verdana, Arial, Helvetica, sans-serif;
        font-size: 13px;
    }

    .tabela_atencao {
        border: 1px solid #FFCC00;
        background-color: #FFF8D9;
        font: 12px Verdana, Arial, Helvetica, sans-serif;
        color: #CC0000;
        text-align: center;
    }
    .bimestre1{
        text-align: center;
        width: 35px;
        min-width: 35px;
        padding: 0px;
    
        /* border: 0px; */
        border-right: 25px;
        border-left: 1px;
        /* border-left: 1px; */
        border-top: 1px;
        border-bottom: 1px;
    }

    .bimestre{
        text-align: center;
        width: 35px;
        min-width: 35px;
        padding: 0px;
    
        /* border: 0px; */
        border-right: 25px;
        /* border-left: 1px; */
        border-top: 1px;
        border-bottom: 1px;
    }
    .table>tbody>tr>td, .table>tbody>tr>th, .table>tfoot>tr>td, .table>tfoot>tr>th, .table>thead>tr>td, .table>thead>tr>th {
        padding: 4px;
        line-height: 1.42857143;
        vertical-align: top;
        border-top: 1px solid #ddd;
    }
  `],
  providers: [ConsultaColegioService]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConsultaColegioService, },
{type: ActivatedRoute, },
{type: Router, },
];
}

function ConsultaColegioComponent_tsickle_Closure_declarations() {
/** @type {?} */
ConsultaColegioComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConsultaColegioComponent.ctorParameters;
/** @type {?} */
ConsultaColegioComponent.prototype.subscription;
/** @type {?} */
ConsultaColegioComponent.prototype.habilitarCarregando;
/** @type {?} */
ConsultaColegioComponent.prototype.codigoEmpresa;
/** @type {?} */
ConsultaColegioComponent.prototype.codigoInstituicao;
/** @type {?} */
ConsultaColegioComponent.prototype.rgmAluno;
/** @type {?} */
ConsultaColegioComponent.prototype.codigoAluno;
/** @type {?} */
ConsultaColegioComponent.prototype.codigoCurso;
/** @type {?} */
ConsultaColegioComponent.prototype.listaCombo;
/** @type {?} */
ConsultaColegioComponent.prototype.turmaSelecionada;
/** @type {?} */
ConsultaColegioComponent.prototype.listaDisciplina;
/** @type {?} */
ConsultaColegioComponent.prototype.parcial;
/** @type {?} */
ConsultaColegioComponent.prototype.disciplinaSelecionada;
/** @type {?} */
ConsultaColegioComponent.prototype.consulta;
/** @type {?} */
ConsultaColegioComponent.prototype.rotaAtivada;
/** @type {?} */
ConsultaColegioComponent.prototype.router;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
